import React from "react";

import { FaInstagram, FaYoutube, FaWhatsapp } from "react-icons/fa";
import {
  Map,
  Call,
  Buliding,
  MessageSquare,
  DirectboxReceive,
  Command,
} from "iconsax-react";

import homeIcon from "../../image/contactUs/home.svg";
import headphone from "../../image/contactUs/headphone.svg";
import command from "../../image/contactUs/command.svg";

export const cardsContent = [
  {
    id: 1,
    image: headphone,
    title: "دفتر فروش و پشتیبانی",
    subTitle: "شرکت فرآموز هنداسه",
    caption: [
      {
        text: "میدان رسالت، خیابان هنگام، بالاتر از فرجام، پلاک 98، طبقه 5، واحد 8.",
        icon: <Map size="24" color="var(--secondary-color)" variant="Bold" />,
      },
      {
        text: (
          <a href="tel:02177187250" title="تماس با آزتو">
            {" "}
            تلفن تماس: 77187250-021 - 77245204
          </a>
        ),
        icon: <Call size="24" color="var(--secondary-color)" variant="Bold" />,
      },
      {
        text: (
          <a href="fax:02177275602" title="فکس به آزتو">
            فکس: 77275602-021
          </a>
        ),
        icon: (
          <DirectboxReceive
            size="24"
            color="var(--secondary-color)"
            variant="Bold"
          />
        ),
      },
      {
        text: (
          <a href="mailto:info@azeto.ir" title="ایمیل به آزتو">
            ایمیل:info@azeto.ir
          </a>
        ),
        icon: (
          <MessageSquare
            size="24"
            color="var(--secondary-color)"
            variant="Bold"
          />
        ),
      },
    ],
  },
  {
    id: 2,
    image: homeIcon,
    title: "دفتر مرکزی",
    subTitle: "پارک فناوری مدرس",
    caption: [
      {
        text: "تهران، کارگر شمالی، خیابان هیأت، پلاک 15، واحد 205، موسسه فرآموز هنداسه.",
        icon: <Map size="24" color="var(--secondary-color)" variant="Bold" />,
      },
      {
        text: (
          <a href="tel:02191082100" title="تماس با دفتر مرکزی آزتو">
            تلفن تماس: 91082100-021 (داخلی 2053)
          </a>
        ),
        icon: <Call size="24" color="var(--secondary-color)" variant="Bold" />,
      },
      {
        text: "کد‌پستی: 1411893171",
        icon: (
          <Buliding size="24" color="var(--secondary-color)" variant="Bold" />
        ),
      },
    ],
  },
  {
    id: 3,
    image: command,
    title: "کانال‌های ارتباطی",
    subTitle: "شبکه‌های اجتماعی آزتو را دنبال کنید",
    socialData: [
      {
        id: 1,
        icon: (
          <FaWhatsapp
            variant="Bold"
            size={25}
            className="icon"
            color="var(--bg-color)"
          />
        ),
        url: "https://api.whatsapp.com/send?phone=989354142159",
      },
      {
        id: 2,
        icon: (
          <FaInstagram
            variant="Bold"
            size={25}
            className="icon"
            color="var(--bg-color)"
          />
        ),
        url: "https://www.instagram.com/azeto.ir/",
      },
      {
        id: 3,
        icon: (
          <FaYoutube
            variant="Bold"
            size={25}
            className="icon"
            color="var(--bg-color)"
          />
        ),
        url: "https://www.youtube.com/channel/UCfNVOqzRl-gyoa3zB__vp4w",
      },
    ],
  },
];
